import { DialogComponent } from '@syncfusion/ej2-react-popups'
import { HelpCenterContent } from './HelpCenterContent'

const HelpCenterModal = ({ isOpen, dialogClose }) => {
  return (
    <DialogComponent
      width="90%"
      height="80%"
      header="Help Center"
      visible={isOpen}
      close={dialogClose}
      enableResize
      resizeHandles={['All']}
      allowDragging
      showCloseIcon
      position={{ X: 'center', Y: 'center' }}
      target="#app"
    >
      <HelpCenterContent />
    </DialogComponent>
  )
}

export default HelpCenterModal
